import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { LIBRARIES } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'access',
    label: 'Access Level',
  },
  {
    key: 'owner',
    label: 'Owner',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/libraries/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const Libraries = () => {
  const { data } = useQuery(LIBRARIES, { fetchPolicy: 'network-only' } );

  return (
    <View>
      <Title>Libraries</Title>

      <Link to="/libraries/new">
        <Text>Build Library</Text>
      </Link>

      {data && (
        <DataTable.Simple
          data={data.libraries}
          columns={columns}
        />
      )}
    </View>
  );
};

export default Libraries;
